import { IconClock } from './svg/IconClock';

import './Icon.style.sass';

export const ClockBlue = () => (
  <div className="clock-blue">
    <IconClock />
  </div>
);
